import { Box } from '@mui/material';
import React from 'react'

const SocialMediaCircleIcon = () => {
  return (
      <>
          <Box display={{ xs: 'none', md: 'block' }}>
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="158"
                  height="158"
                  viewBox="0 0 158 158"
                  fill="none"
              >
                  <circle cx="5.33594" cy="9" r="2" fill="#F1C40F" />
                  <circle cx="3.33594" cy="42" r="3" fill="#F1C40F" />
                  <circle cx="10.3359" cy="74" r="4" fill="#F1C40F" />
                  <circle cx="25.3359" cy="103" r="5" fill="#F1C40F" />
                  <circle cx="48.3359" cy="125" r="6" fill="#F1C40F" />
                  <circle cx="77.3359" cy="142" r="7" fill="#F1C40F" />
                  <circle cx="111.336" cy="149" r="8" fill="#F1C40F" />
                  <circle cx="143.336" cy="149" r="9" fill="#F1C40F" />
              </svg>
          </Box>
          <Box display={{ xs: 'none', sm: 'block', md: 'none' }}>
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="95"
                  height="158"
                  viewBox="0 0 95 158"
                  fill="none"
              >
                  <circle cx="5.33594" cy="9" r="2" fill="#F1C40F" />
                  <circle cx="3.33594" cy="42" r="3" fill="#F1C40F" />
                  <circle cx="10.3359" cy="74" r="4" fill="#F1C40F" />
                  <circle cx="25.3359" cy="103" r="5" fill="#F1C40F" />
                  <circle cx="48.3359" cy="125" r="6" fill="#F1C40F" />
                  <circle cx="77.3359" cy="142" r="7" fill="#F1C40F" />
                  <circle cx="111.336" cy="149" r="8" fill="#F1C40F" />
                  <circle cx="143.336" cy="149" r="9" fill="#F1C40F" />
              </svg>
          </Box>
          <Box display={{ xs: 'block', sm: 'none' }}>
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="86"
                  height="158"
                  viewBox="0 0 86 158"
                  fill="none"
              >
                  <circle cx="5.33594" cy="9" r="2" fill="#F1C40F" />
                  <circle cx="3.33594" cy="42" r="3" fill="#F1C40F" />
                  <circle cx="10.3359" cy="74" r="4" fill="#F1C40F" />
                  <circle cx="25.3359" cy="103" r="5" fill="#F1C40F" />
                  <circle cx="48.3359" cy="125" r="6" fill="#F1C40F" />
                  <circle cx="77.3359" cy="142" r="7" fill="#F1C40F" />
                  <circle cx="111.336" cy="149" r="8" fill="#F1C40F" />
                  <circle cx="143.336" cy="149" r="9" fill="#F1C40F" />
              </svg>
          </Box>
      </>
  );
}

export default SocialMediaCircleIcon
